export const SET_SERVICE_STATUS = 'SET_SERVICE_STATUS';
export const FETCH_SERVICE_STATUS = 'FETCH_SERVICE_STATUS';
